// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__L64HD","title":"AfterBackImages_title__27yhk","images":"AfterBackImages_images__1RtVb"};